import ApiService from '@/services/api.service'

const ReportCategoriesService = {
    getAll( parameter) { 
         
      const requestData = {
        method: 'get',
        url: "/ReportCategories",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber,
        }
      }     
      return ApiService.customRequest(requestData);         
    },
}
  
export default ReportCategoriesService;